import { Injectable } from '@angular/core';

import { LanguagesQuery } from './languages.query';
import { LanguagesStore } from './languages.store';

@Injectable({ providedIn: 'root' })
export class LanguagesService {
  constructor(public query: LanguagesQuery, public store: LanguagesStore) { }
}
